export const columns = [
  { field: 'name', label: 'Name' },
  { field: 'email', label: 'Email' },
  { field: 'phone', label: 'Phone Number' },
  {
    field: 'designtation', label: 'Designtation',
    //  filter: true, options: [
    //   { label: "User", value: "user" },
    //   { label: "Business", value: "business" },
    //   { label: "Delivery Operator", value: "delivery_operator" },
    // ]
  },
  {
    field: 'status', label: 'Status'
  },
  { field: 'action', label: 'Action' }
]

export const rows = [
  {
    id: "123",
    name: "Rutuja Patil",
    email: "sarah.t90@gmail.com",
    phone: "+1284794893",
    designtation: "Admin",
    status: "Active",
  },
  {
    id: "224",
    name: "Priya",
    email: "lily.rivera@gmail.com",
    phone: "+1284794893",
    designtation: "Super Admin",
    status: "Active",
  },
  {
    id: "333",
    name: "Kunal Saxena",
    email: "natalie.smith@gmail.com",
    phone: "+1123659870",
    designtation: "Admin",
    status: "Inactive",
  },
  {
    id: "434",
    name: "Mohit",
    email: "Emily.chen@gmail.com",
    phone: "+1284794893",
    designtation: "Support",
    status: "Inactive",
  },
  {
    id: "544",
    name: "Sarah Thompson",
    email: "john.de@gmail.com",
    phone: "+1284794893",
    designtation: "Customer Care",
    status: "Active",
  },
  {
    id: "655",
    name: "James Anderson",
    email: "natalie.smith@gmail.com",
    phone: "+1321888123",
    designtation: "Admin",
    status: "Inactive",
  },
  {
    id: "1231",
    name: "Rutuja Patil",
    email: "lily.rivera@gmail.com",
    phone: "+1284794893",
    designtation: "Admin",
    status: "Active",
  },
  {
    id: "2241",
    name: "Priya",
    email: "sarah.t90@gmail.com",
    phone: "+1284794893",
    designtation: "Global Admin",
    status: "Active",
   
  },
  {
    id: "331",
    name: "Kunal Saxena",
    email: "john.de@gmail.com",
    phone: "+1123659870",
    designtation: "Admin",
    status: "Inactive",
    type: "Store"
  },
  {
    id: "4341",
    name: "Mohit",
    email: "john.de@gmail.com",
    phone: "+1284794893",
    designtation: "Admin",
    status: "Inactive",
    type: "Delivery"
  },
  {
    id: "5441",
    name: "Sarah Thompson",
    email: "sarah.t90@gmail.com",
    phone: "+1284794893",
    designtation: "Admin",
    status: "Active",
    type: "Delivery"
  },
  {
    id: "6551",
    name: "James Anderson",
    email: "john.de@gmail.com",
    phone: "+1321888123",
    designtation: "Admin",
    status: "Inactive",
    type: "Delivery"
  },
  {
    id: "1232",
    name: "Rutuja Patil",
    email: "sarah.t90@gmail.com",
    phone: "+1284794893",
    designtation: "Support Admin",
    status: "Active",
    type: "Delivery"
  },
  {
    id: "2243",
    name: "Priya",
    email: "lily.rivera@gmail.com",
    phone: "+1284794893",
    designtation: "Support",
    status: "Active",
    type: "Delivery"
  },
  {
    id: "3331",
    name: "Kunal Saxena",
    email: "Emily.chen@gmail.com",
    phone: "+1123659870",
    designtation: "Support",
    status: "Inactive",
    type: "Delivery"
  },
  {
    id: "4341",
    name: "Mohit",
    email: "lily.rivera@gmail.com",
    phone: "+1284794893",
    designtation: "Support",
    status: "Inactive",
    type: "Delivery"
  },
  {
    id: "5443",
    name: "Sarah Thompson",
    email: "sarah.t90@gmail.com",
    phone: "+1284794893",
    designtation: "Support",
    status: "Active",
    type: "Delivery"
  },
  {
    id: "6558",
    name: "James Anderson",
    email: "lily.rivera@gmail.com",
    phone: "+1321888123",
    designtation: "Support",
    status: "Inactive",
    type: "Store"
  },
];


export const permissionColumns = [
  { field: "resource", label: "Resource" },
  { field: "scopes", label: "Scopes" },
  { field: "action", label: "Action" },
];

export const permissionRows = [
  {
    id: "1",
    resource: "User",
    scopes: "Read,View",
  },
  {
    id: "2",
    resource: "User",
    scopes: "Read,View,Edit,Write",
  },
  {
    id: "3",
    resource: "Delivery",
    scopes: "Read,View",
  },
  {
    id: "4",
    resource: "Delivery",
    scopes: "Read,View,Write",
  },

];

export const roleColumns = [
  { field: "rbac_role", label: "Role", width: "150px" },
  { field: "users", label: "Users", width: "80px" },
  { field: "resources_assign", label: "Resources:Scope"},
  { field: "action", label: "Assign Role", width: "120px" }
];

export const roleRows = [
 {
    id: 1,
    rbac_role: "normal user",
    users: 4,

    resources_assign: [
        "normal-user-flow:view,update,write,delete"
    ]
}

];

export const assignColumns = [
  { field: 'name', label: 'Name' },
  { field: 'email', label: 'Email' },
  { field: 'phone', label: 'Phone Number' },
  { field: 'action', label: 'Action' }
]

export const modules = [
  { value: "Dashboard", label: "Dashboard" },
  { value: "User Management", label: "User Management" },
  { value: "RBAC Management", label: "RBAC Management" },
  { value: "Approval Dashboard", label: "Approval Dashboard" },
  { value: "Service Settings", label: "Service Settings" },
  { value: "Configuration Settings", label: "Configuration Settings" },
  { value: "Payment And Payout", label: "Payment And Payout" },
  { value: "Broadcast", label: "Broadcast" },
  { value: "Incedent Reports", label: "Incedent Reports" },




]